import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

import LandingPage from "./views/LandingPage";
import Login from "./views/Login.vue";
import AppPractitioner from "./views/AppPractitioner";

import routerAppDive from "./routerAppDive";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "LandingPage",
      component: LandingPage
    },
    {
      path: "/ingresar",
      name: "Ingreso",
      component: Login,
      meta: { requiresNoAuth: true }
    },
    {
      path: "/costa-pez",
      name: "Home",
      component: AppPractitioner,
      meta: { requiresAuth: true },
      children: [...routerAppDive]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //return next(); // comentar para bloquear vistas
    if (store.getters["authPractitioner/isLoggedIn"]) {
      next();
      return;
    }
    store.dispatch("authPractitioner/saveFromUrl", to.fullPath);
    next("/");
  } else if (to.matched.some(record => record.meta.requiresNoAuth)) {
    if (store.getters["authPractitioner/isLoggedIn"]) {
      let { views = [] } = store.getters["authPractitioner/getPractitioner"];
      let [firstView = {}] = views;
      if (firstView.route) {
        return next(firstView.route);
      } else {
        let [firstModule = {}] = firstView.modules || [];
        return next(firstModule.route);
      }
    }
    next();
  } else {
    next();
  }
});

export default router;
